import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import * as DocumentsActions from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import Amplitude from "../../../../../../../shared/utils/amplitude";
import * as AutomationActions from "../../store/automation-actions";
import * as AutomationGetters from "../../store/automation-getters";
import DocumentAutomationRequestCard from "./document-automation-request/document-automation-request-card.vue";
import DocumentLevelAutomationsLoader from "./loaders/document-level-automations-loader.vue";
import ManageDocumentTypeModal from "../../../../clients/applications/documents/components/documents-page/document-classification/manage-document-types-modal.vue";
import * as DocumentsGetters from "../../../../clients/applications/documents/store/documents-getters";
import DocumentAutomationRequestCardHeader from "./document-automation-request/document-automation-request-card-header.vue";
import { computed, defineComponent, onBeforeMount, onMounted, ref } from "@vue/composition-api";
import { groupBy, isEmpty } from "lodash";
import { useAutomationStoreActions, useAutomationStoreGetters } from "../../store/automation-helpers";
import { useDocumentsStoreActions, useDocumentsStoreGetters } from "@Broker/@Modules/clients/applications/documents/store/document-helpers";
import { toHyphens } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "DocumentLevelAutomations",
  title() {
    return this.$t("sidebar.sections.automation");
  },
  components: {
    DocumentAutomationRequestCard,
    DocumentAutomationRequestCardHeader,
    DocumentLevelAutomationsLoader,
    ManageDocumentTypeModal
  },
  setup() {
    const {
      LOAD_DOCUMENT_REQUEST_AUTOMATIONS
    } = useAutomationStoreActions([AutomationActions.LOAD_DOCUMENT_REQUEST_AUTOMATIONS]);
    const {
      LOAD_DOCUMENT_TYPES
    } = useDocumentsStoreActions([DocumentsActions.LOAD_DOCUMENT_TYPES]);
    const {
      DOCUMENT_REQUESTS_AUTOMATIONS
    } = useAutomationStoreGetters([AutomationGetters.DOCUMENT_REQUESTS_AUTOMATIONS]);
    const documentRequestAutomationsByGroup = computed(() => {
      const {
        byId
      } = DOCUMENT_REQUESTS_AUTOMATIONS.value;
      if (isEmpty(byId)) return [];
      return groupBy(_Object$values(byId), "group");
    });
    const noAutomations = computed(() => documentRequestAutomationsByGroup.value.length === 0);
    const {
      DOCUMENT_TYPES_DATA
    } = useDocumentsStoreGetters([DocumentsGetters.DOCUMENT_TYPES_DATA]);
    const loading = ref(true);
    onMounted(async () => {
      loading.value = true;
      await _Promise.all([LOAD_DOCUMENT_REQUEST_AUTOMATIONS(), LOAD_DOCUMENT_TYPES()]);
      loading.value = false;
    });
    onBeforeMount(() => {
      Amplitude.logEvent("Automations - document level visited");
    });
    const getGroupName = group => toHyphens(group);
    const getGroupKey = group => documentRequestAutomationsByGroup.value[group][0].groupKey;
    return {
      loading,
      noAutomations,
      documentRequestAutomationsByGroup,
      DOCUMENT_TYPES_DATA,
      getGroupName,
      getGroupKey
    };
  }
});